import { getLanguages } from 'api/diam/diamApi';
import { Language } from 'domain/types';
import { useQuery } from 'react-query';
import { diamKeys } from './queryKeyFactory';

export const useDiamLanguages = () => useQuery<{ data: Language[] }>(diamKeys.all, getLanguages);
